import axios from 'axios';
import { getUser, handleLogout } from 'src/utils/Common';
import { getToken, getTokenWs, getIpAddress } from './Common';
import { store } from '../store/configureAppStore'
import { generalActions } from '../store/slices/generalSlice';
import { handleTransactionResponse } from './notificationManager';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

function addHeadOfficeToURL(url) {
    return '/Status' + url;
}

instance.interceptors.request.use(
    function (config) {
        config.url = addHeadOfficeToURL(config.url);
        const AuthToken = getToken();
        const AuthTokenWs = getTokenWs();
        const IpAddress = getIpAddress();
        const user = getUser();
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${AuthToken}`,
            SessionToken: AuthToken,
            SessionTokenWs: AuthTokenWs,
            IpAddress: IpAddress || '',
            'Auth-UserId': user ? user.UserId : '',
            'max-age': 86400,
            'X-Frame-Options': 'DENY',
            'X-XSS-Protection': '1;mode=block',
            Language: localStorage.getItem('i18nextLng')
        };
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    async function (response) {
        return await handleTransactionResponse(response, store, generalActions);
    },
    function (error) {
        if (
            error.response &&
            error.response.data &&
            error.response.data.error === '401 Unauthorized'
        ) {
            alert(
                'Başka bir cihazdan giriş yaptığınız için oturumunuz sonlandırıldı!..'
            );
            handleLogout();
        }
        return Promise.reject(error);
    }
);


export default instance;